import styled, { css } from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';

import ShipmentCard from 'components/orders/ShipmentCard/container';

export default styled(ShipmentCard)`
  display: grid;
  display: -ms-grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: ${gridSizes('M')};
  flex: 1;
  list-style: none;
  background-color: var(--white);
  border-radius: ${gridSizes('S')};
  padding: ${gridSizes('M')} 0;
  margin: ${gridSizes('M')} 0;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.27);
  position: relative;
  cursor: pointer;

  ${(props) =>
    !!props.isTenant &&
    css`
      padding-bottom: 0;
    `}

  .tooltipContainer {
    position: absolute;
    right: 15px;
    top: 40px;
  }

  .pending_appointment {
    color: var(--grey700);
    text-transform: initial;
  }

  &:hover {
    background-color: rgba(240, 242, 246, 0.5);
  }
  ${media.lessThan('extraSmall')`
    display: flex;
    flex-direction: column;
    margin: ${gridSizes('S')} 0;
    padding: ${gridSizes('M')} 0;
  `};
  .more-actions {
    ${media.lessThan('extraSmall')`
      display: none;
    `};
  }
  .share-actions {
    position: absolute;
    right: ${gridSizes('S')};
    bottom: ${gridSizes('S')};

    button {
      border-radius: ${gridSizes('XS')};
      padding: ${gridSizes('XS')};
      background: none;
      display: block;
      border: none;
      cursor: pointer;

      &:hover {
        background-color: var(--primary100);
      }

      svg {
        path {
          fill: var(--primary500);
        }
      }
    }
  }
  .status-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--grey700);
    grid-column: span 4;
    -ms-grid-column: 1;
    -ms-grid-column-span: 7;
    padding-left: ${gridSizes('L')};
    ${media.lessThan('extraSmall')`
      padding-left: 10px;
    `};
  }
  .ref {
    font-size: 14px;
    font-weight: ${weights('medium')};
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin-top: 2px;
  }
  .stops-info {
    width: 100%;
    display: flex;
    color: var(--grey900);
    grid-column: span 8;
    -ms-grid-column: 9;
    -ms-grid-column-span: 16;

    ${media.lessThan('extraSmall')`

    `};
  }
  .pickup {
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 18px;
    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    ${media.lessThan('extraSmall')`
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      padding: 0 10px;
    `};
  }
  .dropoff {
    max-width: 50%;
    padding-right: 48px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    ${media.lessThan('small')`
    padding-right: ${gridSizes('L')};
    `};

    ${media.lessThan('extraSmall')`
      display: flex;
      flex-direction: column;
      padding-right: 10px;
    `};
  }

  .dropoff-appointment {
    padding-right: 4px;
  }

  .stop-date {
    font-size: 14px;
    margin: 0 4px 0 0;
    text-transform: capitalize;
    ${media.lessThan('extraSmall')`
      order: 2;
      margin: 0 0 4px;
    `};
  }
  .stop-time {
    font-size: 14px;
    ${media.lessThan('extraSmall')`
      order: 3;
    `};
  }
  .stop-data {
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${gridSizes('M')};
    margin: 4px 0;
    font-weight: ${weights('medium')};
    ${media.lessThan('extraSmall')`
      order: 1;
      margin: 4px 0 2px;
    `};
  }
  .stop-location {
    font-size: 14px;
    color: var(--grey700);
    ${media.lessThan('extraSmall')`
      display: none;
    `};
  }
  .custom-references {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: ${gridSizes('M')};
    flex: 1;
    list-style: none;
    background-color: var(--white);
    padding: ${gridSizes('S')} 0;
    margin: 0;
    position: relative;
    grid-column: span 12;
    background: var(--grey200);
  }
  .custom-reference {
    grid-column: span 6;
  }
  .custom-reference:first-child {
    padding-left: ${gridSizes('L')};
  }
`;
